import React, { useState } from 'react';

const LanguageSelector = ({ onLanguageChange, lang='es' }) => { 
    const [selectedLanguage, setSelectedLanguage] = useState(lang); 
  
    const handleLanguageChange = (event) => {
      setSelectedLanguage(event.target.value);
      if (onLanguageChange) { 
        onLanguageChange(event.target.value); 
      }
    };
    
    const languages = [
        { code: 'es', name: 'Español', flag: 'assets/flags/spain.svg' },
        { code: 'en', name: 'English', flag: 'assets/flags/united-kingdom.svg' },
        { code: 'de', name: 'Deutsch', flag: 'assets/flags/germany.svg' },
        { code: 'ca', name: 'Català', flag: 'assets/flags/catalonia.svg' },
        { code: 'eu', name: 'Euskara', flag: 'assets/flags/euskadi.svg' },
        { code: 'gl', name: 'Galego', flag: 'assets/flags/galicia.svg' },
        /*
        { code: 'es', name: 'Español', flag: '🇪🇸' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
        { code: 'ca', name: 'Català', flag: 'Catalan flag' },
        { code: 'eu', name: 'Euskara', flag: 'Ikurriña' },
        { code: 'gl', name: 'Galego', flag: 'Galician flag' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'pt', name: 'Português', flag: '🇵🇹' },
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'ru', name: 'Русский', flag: '🇷🇺' },
        { code: 'pl', name: 'Polski', flag: '🇵🇱' },
        { code: 'at', name: 'Österreichisch', flag: '🇦🇹' },
        { code: 'va', 'Valencià', flag: 'Valencian flag' }
        */
    ];
    
    const [languageOpen, setLanguageOpen] = useState(false);
    const currentLanguage = languages.find((language) => language.code === selectedLanguage) || languages[0];

    return (
        <div
  style={{
    position: 'absolute',
    top: '20px',
    right: '20px',
    zIndex: 1000,
  }}
>
  {/* Selector visible */}
  <button
    type="button"
    onClick={() => setLanguageOpen(!languageOpen)}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '7px 10px',
      background: '#fff',
      border: '1px solid #ccc',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '16px',
      minWidth: '135px',
    }}
  >
    <img
      src={currentLanguage.flag}
      alt={currentLanguage.name}
      style={{
        width: '24px',
        height: '16px',
        objectFit: 'cover',
        borderRadius: '2px',
      }}
    />

    <span style={{ flex: 1, textAlign: 'left' }}>
      {currentLanguage.name}
    </span>

    <span style={{ fontSize: '11px' }}>▼</span>
  </button>

  {/* Desplegable */}
  {languageOpen && (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        marginTop: '4px',
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        overflow: 'hidden',
        minWidth: '160px',
      }}
    >
      {languages.map((language) => (
        <div
          key={language.code}
          onClick={() => {
            handleLanguageChange({
              target: { value: language.code },
            });
            setLanguageOpen(false);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '9px 12px',
            cursor: 'pointer',
            background:
              selectedLanguage === language.code
                ? '#f2f2f2'
                : '#fff',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f2f2f2';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              selectedLanguage === language.code
                ? '#f2f2f2'
                : '#fff';
          }}
        >
          <img
            src={language.flag}
            alt=""
            style={{
              width: '26px',
              height: '18px',
              objectFit: 'cover',
              borderRadius: '2px',
              flexShrink: 0,
            }}
          />

          <span>{language.name}</span>

          {selectedLanguage === language.code && (
            <span style={{ marginLeft: 'auto' }}>✓</span>
          )}
        </div>
      ))}
    </div>
  )}
</div>
        // <div style={{height: '0px', position: 'absolute', top: '20px', right: '20px'}}>
        //     <select value={selectedLanguage} onChange={handleLanguageChange}>
        //     {languages.map((language) => (
        //         <option key={language.code} value={language.code}>
        //         {language.flag} {language.name}
        //         </option>
        //     ))}
        //     </select>
        // </div>
    );
};

export default LanguageSelector;